<template>
  <div class="content" id="people-list">
    <div class="header">
      <h1>{{ pageTitle }}</h1>
    </div>
    <div class="content-body form-wrapper quote-form-wrapper">
      <div class="block">
        <div class="people-finder--filter" style="display: flex; flex-flow: row; justify-content: flex-start; gap: 10px;">
          <DepartmentSelect v-model="filter.department_id" :placeholder="$t('people.department')" clearable></DepartmentSelect>
          <Input v-model="filter.fullname_cn" :placeholder="$t('people.chinese_name')"></Input>
          <Input v-model="filter.fullname_en" :placeholder="$t('people.english_name')"></Input>
          <Input v-model="filter.erp_id" :placeholder="$t('people.erp_id')"></Input>
          <Input v-model="filter.email" :placeholder="$t('people.email')"></Input>
          <Button type="primary" @click="findPeople">{{ $t('order.search_go') }}</Button>
        </div>
        <div style="margin: 20px 0"></div>
        <vxe-toolbar>
          <template #buttons>
            <div class="text-align-right">
              <Button type="warning" @click="handlePeopleSync" style="margin-right: 1.5rem;">{{ $t('people.sync_people') }}</Button>
              <Button type="primary" @click="$router.push({ name: 'menu.people.new' })">{{ $t('people.new_people') }}</Button>
            </div>
          </template>
        </vxe-toolbar>
        <vxe-table :data="peopleList.data" size="mini" border>
          <vxe-table-column type="seq" align="center" width="40"></vxe-table-column>
          <vxe-table-column field="fullname_cn" :title="$t('people.chinese_name')" :min-width="120"></vxe-table-column>
          <vxe-table-column field="fullname_en" :title="$t('people.english_name')" :min-width="180"></vxe-table-column>
          <vxe-table-column field="gender" :title="$t('people.gender')" width="80" align="center">
            <template #default="{ row }">{{ $t(row.gender.toLowerCase()) }}</template>
          </vxe-table-column>
          <vxe-table-column field="department.name" :title="$t('people.department')" width="200"></vxe-table-column>
          <vxe-table-column field="email" :title="$t('people.email')" width="200"></vxe-table-column>
          <vxe-table-column field="country" :title="$t('people.country')" width="80" align="center"></vxe-table-column>
          <vxe-table-column field="erp_id" :title="$t('people.erp_id')" width="120"></vxe-table-column>
          <vxe-table-column field="dingtalk_id" :title="$t('people.dingtalk_id')" width="200"></vxe-table-column>
          <vxe-table-column :title="$t('order.actions')" width="130" align="center">
            <template #default="{ row }">
              <router-link :to="{ name: 'menu.people.detail', params: { id: row.id } }">{{ $t('edit') }}</router-link>
            </template>
          </vxe-table-column>
        </vxe-table>

        <vxe-pager
            border
            icon-prev-page="fa fa-angle-left"
            icon-jump-prev="fa fa-angle-double-left"
            icon-jump-next="fa fa-angle-double-right"
            icon-next-page="fa fa-angle-right"
            icon-jump-more="fa fa-ellipsis-h"
            :loading="loading"
            :current-page="pager.current_page"
            :page-size="pager.per_page"
            :total="pager.total"
            :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
            @page-change="handlePageChange">
          </vxe-pager>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { DepartmentSelect } from './components'
export default {
  name: 'PeopleList',
  components: {
    DepartmentSelect
  },
  data () {
    return {
      pager: {
        current_page: 1,
        per_page: 15,
        page: 1
      },
      loading: false,
      filter: {}
    }
  },
  computed: {
    ...mapGetters(['peopleList']),
    pageTitle () {
      return this.$t('menu.people.list_title')
    }
  },
  mounted () {
    this.findPeople()
  },
  methods: {
    ...mapActions(['getPeopleList', 'syncPeople']),
    findPeople () {
      this.getPeopleList(this.buildQuery()).then(resp => {
        this.pager = (({ per_page, current_page, total }) => ({ per_page, current_page, total }))(resp.data.meta)
      })
    },
    buildQuery () {
      let search = Object.entries(this.filter).filter(([_, v]) => v).map((e) => {
        return e.join(':')
      }).join(';')

      return Object.assign({}, { search: search, searchJoin: 'and' }, this.pager)
    },
    handlePageChange ({ currentPage, pageSize }) {
      this.pager.page = currentPage
      this.pager.per_page = pageSize
      this.findPeople()
    },
    handlePeopleSync() {
      this.syncPeople().then((resp) => {
        console.log(resp.message)
        this.$Message.success(resp.message)
      })
    }
  }
}
</script>
